var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('BaseLoading',{attrs:{"is-full-page":""}}):_c('OnSiteMessageStripForm',{attrs:{"is-edit-mode":"","is-loading":_vm.isLoading,"is-updating":_vm.isUpdating,"data":_vm.data},on:{"onSubmit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }